
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M9.63999 7.64C9.92999 7.02 10.06 6.31 9.97999 5.55C9.78999 3.82 8.43999 2.35 6.71999 2.06C3.94999 1.58 1.57999 3.95 2.05999 6.71C2.35999 8.43 3.81999 9.78 5.54999 9.97C6.30999 10.05 7.00999 9.92 7.63999 9.63L9.99999 12L7.63999 14.36C7.01999 14.07 6.30999 13.94 5.54999 14.02C3.81999 14.21 2.34999 15.56 2.05999 17.28C1.57999 20.05 3.94999 22.41 6.70999 21.93C8.42999 21.63 9.77999 20.17 9.96999 18.44C10.05 17.68 9.91999 16.98 9.62999 16.35L12 14L19.59 21.59C20.48 22.48 22 21.85 22 20.59V20.58C22 20.21 21.85 19.85 21.59 19.58L9.63999 7.64ZM5.99999 8C4.89999 8 3.99999 7.11 3.99999 6C3.99999 4.89 4.89999 4 5.99999 4C7.09999 4 7.99999 4.89 7.99999 6C7.99999 7.11 7.09999 8 5.99999 8ZM5.99999 20C4.89999 20 3.99999 19.11 3.99999 18C3.99999 16.89 4.89999 16 5.99999 16C7.09999 16 7.99999 16.89 7.99999 18C7.99999 19.11 7.09999 20 5.99999 20ZM12 12.5C11.72 12.5 11.5 12.28 11.5 12C11.5 11.72 11.72 11.5 12 11.5C12.28 11.5 12.5 11.72 12.5 12C12.5 12.28 12.28 12.5 12 12.5ZM19.59 2.41L13 9L15 11L21.59 4.41C21.85 4.15 22 3.79 22 3.41V3.4C22 2.15 20.48 1.52 19.59 2.41Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-content-cut`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconContentCut

    ```js
    <b-new-b-icon-content-cut />
    ```
</docs>


